import script from "./ChangeCategoryDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeCategoryDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./ChangeCategoryDrawer.vue?vue&type=style&index=0&id=5813b9d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5813b9d3"]])

export default __exports__